import React from 'react';
import s from '../../pages/PDV.module.css';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ModalBuscarMovimentacao({ modalBuscarMov, setModalBuscarMov, filtrosMov, setFiltroMov, setFiltrosMov, FILTROS_MOV_VAZIOS, tiposMovimentoMov = [], buscarMovimentacoes, buscandoMov, movimentacoes, setMovimentacoes, movSelecionada, setMovSelecionada, resultadoDocMov, setResultadoDocMov, dadosDiagnostico, setModalDiagnostico, abrirCorrecaoFiscal, emitindoDocMov, emitirDocFiscalMov, cancelarDocFiscalMov, cancelarVendaMov, imprimirDanfeNfceMov, previewDanfeMov, imprimindoMov, imprimirMovimentacao, abrirDanfeNfePdf, gerarDanfeNfce, larguraCupom, itensServicoMov = [], emitirNfseItemMov, nfseEmitindoMov, nfseResultadosMov, enviarWhatsappMov, enviarEmailMov, enviandoEmailMov }) {
  // Mantém a linha selecionada visível ao navegar com as setas
  const linhaSelRef = React.useRef(null);
  React.useEffect(() => {
    linhaSelRef.current?.scrollIntoView?.({ block: 'nearest' });
  }, [movSelecionada?.id]);

  if (!modalBuscarMov) return null;
  // Cliente pessoa jurídica: NFC-e não fica disponível para transmissão (só NF-e/NFS-e).
  const clientePJ = movSelecionada?.cliente_tipo_pessoa === 'J';
  return (
        <div className={s.modalOverlay} onClick={() => setModalBuscarMov(false)}>
          <div className={s.modalBuscarMov} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>F7 — Buscar Movimentação de Caixa</span>
              <button className={s.modalClose} onClick={() => setModalBuscarMov(false)}>✕</button>
            </div>

            {/* Filtros */}
            <div className={s.movFiltros}>
              <div className={s.movFiltroGrid}>
                {[
                  ['Período início','dataInicio','date'],['Período fim','dataFim','date'],
                  ['Operador','operador','text'],['Terminal','terminal','text'],
                  ['Cliente','cliente','text'],['Código','codigo','text'],
                  ['NF-e','nfe','text'],['Total R$','total','text'],
                ].map(([label, campo, tipo]) => (
                  <div key={campo} className={s.movCampo}>
                    <label className={s.f3Label}>{label}:</label>
                    <input className={s.f3Input} type={tipo}
                      value={filtrosMov[campo]}
                      onChange={e => setFiltroMov(campo, e.target.value)} />
                  </div>
                ))}
                <div className={s.movCampo}>
                  <label className={s.f3Label}>Finalização:</label>
                  <select className={s.f3Input} value={filtrosMov.finalizacao}
                    onChange={e => setFiltroMov('finalizacao', e.target.value)}>
                    <option value="">Todas</option>
                    <option value="nfce">NFC-e</option>
                    <option value="nfe">NF-e</option>
                    <option value="nfe_nfse">NF-e/NFS-e</option>
                  </select>
                </div>
                <div className={s.movCampo}>
                  <label className={s.f3Label}>Tipo de Movimento:</label>
                  <select className={s.f3Input} value={filtrosMov.operacao}
                    onChange={e => setFiltroMov('operacao', e.target.value)}>
                    <option value="">Todos</option>
                    {tiposMovimentoMov.map(t => (
                      <option key={t.id} value={t.id}>{t.nome}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={s.movChecksRow}>
                <label className={s.f3CheckLabel}>
                  <input type="checkbox" checked={filtrosMov.excluidas}
                    onChange={e => setFiltroMov('excluidas', e.target.checked)} />
                  Excluídas
                </label>
              </div>
              <div className={s.f3FiltrarRow}>
                <button className={s.f3BtnFiltrar} onClick={() => buscarMovimentacoes()}>Filtrar</button>
                <button className={s.f3BtnLimpar} onClick={() => { setFiltrosMov(FILTROS_MOV_VAZIOS); setMovimentacoes([]); }}>Limpar</button>
                {buscandoMov && <span className={s.f3Buscando}>Buscando…</span>}
              </div>
            </div>

            {/* Grade */}
            <div className={s.f3GridWrap}>
              <table className={s.f3Grid}>
                <thead>
                  <tr>
                    <th style={{width:70}}>Código</th>
                    <th style={{width:150}}>Cliente</th>
                    <th style={{width:100}}>Quem Lançou</th>
                    <th style={{width:100}}>Vendedor</th>
                    <th style={{width:120}}>Data</th>
                    <th style={{width:85}} className={s.right}>Total R$</th>
                    <th style={{width:80}} className={s.right}>Pago R$</th>
                    <th style={{width:70}} className={s.right}>Troco R$</th>
                    <th style={{width:80}} className={s.right}>Líquido R$</th>
                    <th style={{width:65}}>Doc. Fiscal</th>
                    <th style={{width:55}}>Série</th>
                    <th style={{width:90}}>Nº Nota</th>
                    <th style={{width:80}}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {movimentacoes.length === 0 && !buscandoMov && (
                    <tr><td colSpan={13} className={s.f3Vazio}>Use os filtros acima para buscar movimentações.</td></tr>
                  )}
                  {movimentacoes.map((m, i) => {
                    const troco   = parseFloat(m.troco   || 0);
                    // m.pagamento já é o valor LÍQUIDO (venda_pagamentos.valor grava
                    // o que a loja efetivamente ficou, trocoRestante já descontado no
                    // pagamento em dinheiro) — "Pago" na grade mostra bruto (o que o
                    // cliente entregou) somando o troco de volta, e "Líquido" é o
                    // próprio valor líquido, sem subtrair o troco de novo.
                    const pago    = parseFloat(m.pagamento || 0) + troco;
                    const liquido = parseFloat(m.pagamento || 0);
                    return (
                    <tr
                      key={m.id || i}
                      ref={movSelecionada?.id === m.id ? linhaSelRef : null}
                      className={movSelecionada?.id === m.id ? s.movLinhaAtiva : ''}
                      onClick={() => { setMovSelecionada(m); setResultadoDocMov(null); }}
                      style={{ cursor: 'pointer' }}
                    >
                      <td>{m.codigo}</td><td>{m.cliente}</td>
                      <td style={{fontSize:11}}>{m.usuario_nome || <span style={{color:'#aaa'}}>—</span>}</td>
                      <td style={{fontSize:11}}>{m.vendedor_nome || <span style={{color:'#aaa'}}>—</span>}</td>
                      <td>{m.data ? new Date(m.data).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                      <td className={s.right}>{fmtBRL(m.total)}</td>
                      <td className={s.right}>{fmtBRL(pago)}</td>
                      <td className={s.right} style={troco > 0 ? {color:'#b45309'} : {color:'#bbb'}}>{troco > 0 ? fmtBRL(troco) : '—'}</td>
                      <td className={s.right} style={{fontWeight:'bold'}}>{fmtBRL(liquido)}</td>
                      <td style={{fontSize:11}}>
                        {m.doc_fiscal_tipo === 'nfce' ? 'NFC-e'
                          : m.doc_fiscal_tipo === 'nfe' ? (m.tem_nfse ? 'NF-e/NFS-e' : 'NF-e')
                          : m.doc_fiscal_tipo === 'nfse' ? 'NFS-e'
                          : <span style={{color:'#aaa'}}>—</span>}
                      </td>
                      <td style={{fontSize:11}}>
                        {m.doc_fiscal_serie || <span style={{color:'#aaa'}}>—</span>}
                      </td>
                      <td style={{fontSize:11, whiteSpace:'nowrap'}}>
                        {m.doc_fiscal_numero
                          ? <>
                              {m.doc_fiscal_numero}
                              {/* Cancelamento pela SEFAZ (NF-e/NFC-e) já existe; NFS-e
                                  ainda não tem cancelamento no sistema (de propósito —
                                  ver decisão de adiar isso, sessão de estabilização da
                                  emissão) — o botão nem aparece pra não sugerir uma ação
                                  que hoje só devolveria erro/seria feita manualmente no
                                  portal nacional. */}
                              {m.doc_fiscal_status === 'autorizada' && m.doc_fiscal_tipo !== 'nfse' && (
                                <button
                                  style={{ marginLeft: 6, border: '1px solid #b91c1c', background: '#fff',
                                    color: '#b91c1c', borderRadius: 3, fontSize: 10, cursor: 'pointer',
                                    padding: '0 4px', lineHeight: '14px' }}
                                  title="Cancelar este documento na SEFAZ (senha de administrador; sujeito ao prazo legal de cancelamento)"
                                  onClick={e => { e.stopPropagation(); setMovSelecionada(m); cancelarDocFiscalMov(m); }}>
                                  ✕
                                </button>
                              )}
                            </>
                          : <span style={{color:'#aaa'}}>—</span>}
                      </td>
                      <td>
                        {m.doc_fiscal_status === 'autorizada' && <span className={s.badgeFiscalOk}>Autorizada</span>}
                        {m.doc_fiscal_status === 'rejeitada'  && <span className={s.badgeFiscalErr}>Rejeitada</span>}
                        {m.doc_fiscal_status === 'pendente'   && <span className={s.badgeFiscalPend}>Pendente</span>}
                        {m.doc_fiscal_status === 'cancelada'  && <span className={s.badgeFiscalErr} style={{opacity:0.7}}>Cancelada</span>}
                        {!m.doc_fiscal_status && <span style={{color:'#aaa',fontSize:11}}>—</span>}
                      </td>
                    </tr>
                  );})}

                </tbody>
              </table>
            </div>

            {/* Resultado de emissão inline */}
            {resultadoDocMov && (
              <div className={resultadoDocMov.sucesso ? s.movResultOk : s.movResultErr}>
                <strong>{resultadoDocMov.sucesso ? '✔ Autorizado' : '✘ Rejeitado/Erro'}</strong>
                <span>{resultadoDocMov.motivo}</span>
                {resultadoDocMov.chave_acesso && (
                  <span style={{fontSize:10, wordBreak:'break-all'}}>
                    Chave: {resultadoDocMov.chave_acesso}
                  </span>
                )}
                {resultadoDocMov.protocolo && (
                  <span>Protocolo: {resultadoDocMov.protocolo}</span>
                )}
                {/* Lista de produtos com campos fiscais faltando */}
                {dadosDiagnostico && (
                  <button className={s.movBtnDiag} onClick={() => setModalDiagnostico(true)}>
                    🔍 Ver diagnóstico completo
                  </button>
                )}
                {resultadoDocMov.detalhes_fiscais?.length > 0 && (
                  <div className={s.movResultDetalhes}>
                    {resultadoDocMov.detalhes_fiscais.map((d, i) => (
                      <div key={i}>
                        <strong>{d.produto}</strong>
                        <span className={s.movResultCampos}>
                          {d.campos_faltando.join(' · ')} faltando
                        </span>
                      </div>
                    ))}
                    {resultadoDocMov.detalhes_fiscais.some(d => d.produto_id) && (
                      <button
                        className={s.movBtnCorrigir}
                        onClick={() => abrirCorrecaoFiscal(resultadoDocMov.tipo)}
                      >
                        ✏️ Corrigir Dados Fiscais
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Serviços da venda selecionada — NFS-e emitida depois (venda pode ter
                sido salva sem doc fiscal, ou com NFC-e/NF-e só da parte de mercadoria) */}
            {movSelecionada && itensServicoMov.length > 0 && (
              <div style={{ background: '#f5f3ff', border: '1px solid #a78bfa', borderRadius: 6,
                padding: '6px 10px', margin: '0 12px 8px', fontSize: 11.5, color: '#4c1d95' }}>
                <div style={{ fontWeight: 700, marginBottom: 4 }}>🧾 Serviços desta venda (NFS-e)</div>
                {itensServicoMov.map(item => {
                  const resultado = nfseResultadosMov?.[item.id];
                  return (
                    <div key={item.id} style={{ marginBottom: 4 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                        <span>{item.descricao} — R$ {fmtBRL(item.subtotal)}</span>
                        <button style={{ padding: '2px 8px', fontSize: 11, cursor: 'pointer',
                          border: '1px solid #7c3aed', borderRadius: 4, background: '#fff', color: '#7c3aed' }}
                          disabled={nfseEmitindoMov === item.id}
                          onClick={() => emitirNfseItemMov(item)}>
                          {nfseEmitindoMov === item.id ? 'Gerando…' : '🧾 Gerar DANFE'}
                        </button>
                      </div>
                      {resultado && (resultado.erro || resultado.motivo) && (
                        <div style={{ marginTop: 2, fontSize: 10.5, color: resultado.sucesso ? '#57534e' : '#b91c1c' }}>
                          {resultado.erro || resultado.motivo}
                          {resultado.status ? ` (status ${resultado.status})` : ''}
                        </div>
                      )}
                      {resultado?.sucesso && (
                        <div style={{ marginTop: 2, fontSize: 10.5, color: '#15803d' }}>
                          ✔ NFS-e nº {resultado.numero_nfse} emitida com sucesso.
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            <div className={s.f3Rodape}>
              <div className={s.movInfoSelecionada}>
                {movSelecionada ? (
                  <span>
                    Venda #{movSelecionada.codigo}
                    {movSelecionada.doc_fiscal_chave &&
                      <> · Chave: {movSelecionada.doc_fiscal_chave.substring(0,20)}…</>}
                    {movSelecionada.doc_fiscal_protocolo &&
                      <> · Prot: {movSelecionada.doc_fiscal_protocolo}</>}
                  </span>
                ) : 'Clique em uma linha para selecionar'}
              </div>
              <div className={s.f3BotoesRodape}>
                {emitindoDocMov && <span className={s.f3Buscando}>Transmitindo…</span>}

                {movSelecionada && !emitindoDocMov && (<>
                  {/* Sem documento, rejeitada, cancelada ou pendente (envio sem resposta da SEFAZ —
                      emitir de novo faz o backend consultar a SEFAZ antes) → botões de emissão + prévia */}
                  {(!movSelecionada.doc_fiscal_status || ['rejeitada', 'cancelada', 'pendente'].includes(movSelecionada.doc_fiscal_status)) && (<>
                    {/* Cliente pessoa jurídica: só NF-e/NFS-e ficam disponíveis para transmissão */}
                    {!clientePJ && (<>
                      <button className={s.movBtnFiscal}
                        onClick={() => emitirDocFiscalMov('nfce')}>
                        🔄 Emitir NFC-e
                      </button>
                      <button className={s.fiscalBtnPrevia} disabled={imprimindoMov}
                        onClick={() => previewDanfeMov('nfce')}>
                        Prévia NFC-e
                      </button>
                    </>)}
                    <button className={s.movBtnFiscal}
                      onClick={() => emitirDocFiscalMov('nfe')}>
                      🔄 Emitir NF-e
                    </button>
                    <button className={s.fiscalBtnPrevia} disabled={imprimindoMov}
                      onClick={() => previewDanfeMov('nfe')}>
                      Prévia NF-e
                    </button>
                  </>)}

                  {/* Autorizada → imprimir DANFE + cancelar na SEFAZ — SÓ NF-e/NFC-e.
                      Achado ao vivo (RBDIGITAL): doc_fiscal_tipo/status/id vêm
                      COALESCIDOS entre NF-e/NFC-e e NFS-e (ver
                      vendasController.listar — mesmo id de documentos_fiscais é
                      compartilhado entre os tipos), então numa venda 100% serviço
                      (só NFS-e autorizada) esses 2 botões apareciam igual — e
                      "Imprimir DANFE" caía no branch de NFC-e (que não sabe lidar
                      com NFS-e) e abriu o DANFE de uma NFC-e qualquer, sem nenhuma
                      relação com a venda selecionada. "Cancelar" tinha o mesmo
                      problema, e ali era mais grave: chegou a montar um evento de
                      cancelamento de NF-e de verdade com a chave da NFS-e (ver
                      vendasController.cancelar, já corrigido lá também). NFS-e tem
                      seu próprio botão "Gerar DANFE" no bloco "Serviços desta
                      venda (NFS-e)" acima — cancelamento de NFS-e ainda não existe
                      no sistema (decisão de adiar, tomada na estabilização da
                      emissão). */}
                  {movSelecionada.doc_fiscal_status === 'autorizada'
                    && (movSelecionada.doc_fiscal_tipo === 'nfce' || movSelecionada.doc_fiscal_tipo === 'nfe') && (<>
                    <button className={s.movBtnImprimir} disabled={imprimindoMov}
                      onClick={() => {
                        if (movSelecionada.doc_fiscal_tipo === 'nfe') {
                          abrirDanfeNfePdf(`/fiscal/nfe/${movSelecionada.doc_fiscal_id}/danfe`);
                        } else {
                          imprimirDanfeNfceMov();
                        }
                      }}>
                      🖨️ Imprimir DANFE
                    </button>
                    <button className={s.movBtnFiscal}
                      style={{ background: '#b91c1c', color: '#fff' }}
                      title="Cancela o documento na SEFAZ (evento 110111 — exige senha de administrador)"
                      onClick={cancelarDocFiscalMov}>
                      ✕ Cancelar {movSelecionada.doc_fiscal_tipo === 'nfe' ? 'NF-e' : 'NFC-e'}
                    </button>
                  </>)}

                  {/* WhatsApp/E-mail servem pra qualquer doc autorizado — NF-e/
                      NFC-e OU NFS-e — mandam o que existir de verdade (boleto/
                      nota), ver vendasController.compartilhar/enviarEmailDocumentos.
                      Por isso ficam FORA do bloco acima, sem o filtro de tipo. */}
                  {movSelecionada.doc_fiscal_status === 'autorizada' && (<>
                    <button className={s.movBtnImprimir} onClick={enviarWhatsappMov}
                      title="Abre o WhatsApp com uma mensagem pronta (link do boleto/nota) pro número cadastrado do cliente — você confere e aperta Enviar lá dentro">
                      💬 WhatsApp
                    </button>
                    <button className={s.movBtnImprimir} onClick={enviarEmailMov} disabled={enviandoEmailMov}>
                      {enviandoEmailMov ? 'Enviando...' : '📧 E-mail'}
                    </button>
                  </>)}

                  {/* Pendente → reenviar */}
                  {movSelecionada.doc_fiscal_status === 'pendente' && (
                    <button className={s.movBtnFiscal}
                      onClick={() => emitirDocFiscalMov(movSelecionada.doc_fiscal_tipo || 'nfce')}>
                      🔄 Reenviar
                    </button>
                  )}

                  {/* Cancelar a venda inteira (estoque + financeiro + doc fiscal) */}
                  {movSelecionada.status === 'concluida' && (
                    <button className={s.movBtnFiscal}
                      style={{ background: '#7f1d1d', color: '#fff' }}
                      title="Cancela a venda: devolve o estoque, desfaz o financeiro e cancela o documento fiscal autorizado na SEFAZ (senha de administrador)"
                      onClick={cancelarVendaMov}>
                      🚫 Cancelar Venda
                    </button>
                  )}

                  {/* Impressão cupom/a4 sempre disponível */}
                  <button className={s.movBtnImprimir} disabled={imprimindoMov}
                    onClick={() => imprimirMovimentacao('termica')}>
                    🖨️ Térmica
                  </button>
                  <button className={s.movBtnImprimir} disabled={imprimindoMov}
                    onClick={() => imprimirMovimentacao('a4')}>
                    📄 A4
                  </button>
                </>)}
                <button className={s.f3BtnSair} onClick={() => setModalBuscarMov(false)}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
  );
}
